import Content from "../Admin/Home/Example"

export const Alquimista =()=> {
    return (
        <Content />
    )
}